module.exports = __webpack_public_path__ + "img/Phone_03.75345164.jpg";